export const getFileUrl = (pathToFile: string, container: string) => {
    if(pathToFile && container)
      return (process.env.REACT_APP_MEDIA_URL || '') + `/${container}/` + pathToFile
    return '';
};